import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ThemeMode, ThemePersistenceAdapter } from '@tiltgroup/web-components';
import { UserSettingsQueriesService } from '@services/queries/services/user-settings-queries.service';

const THEME_SETTING_KEY = 'theme';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsThemeAdapter implements ThemePersistenceAdapter {
  private _userSettingsService = inject(UserSettingsQueriesService);

  load(): Observable<ThemeMode | null> {
    return this._userSettingsService.getUserSettings().pipe(
      map((settings) => {
        const value = settings.find((s) => s.key === THEME_SETTING_KEY)?.value;
        if (value === 'light' || value === 'dark' || value === 'system') {
          return value as ThemeMode;
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }

  save(mode: ThemeMode): Observable<unknown> {
    return this._userSettingsService
      .updateUserSetting([{ key: THEME_SETTING_KEY, value: mode }])
      .pipe(catchError(() => of(null)));
  }
}
